import React from 'react';

export interface IViewsProps {
  className?: string;
}

export const ViewsIcon: React.FC<IViewsProps> = ({ className }) => {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" className={className}>
      <path
        d="M2.143 10S5 4.286 10 4.286 17.857 10 17.857 10 15 15.714 10 15.714 2.143 10 2.143 10Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10 12.143a2.143 2.143 0 1 0 0-4.286 2.143 2.143 0 0 0 0 4.286Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
